import * as Yup from "yup";

import {
  Button,
  Card,
  Col,
  Dropdown,
  InputGroup,
  Row,
} from "@themesberg/react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  faBoxOpen,
  faCartArrowDown,
  faChartPie,
  faChevronDown,
  faClipboard,
  faCommentDots,
  faFileAlt,
  faPlus,
  faRocket,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { selectOTPtype, selectSitetype } from "../SelectOption";

import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Rolling from "../../assets/img/Rolling.gif";
import Select from "react-select";
import TextError from "../TextError";
import bluetooth from "../../assets/img/bluetooth.png";
import { connect } from "react-redux";
import moment from "moment-timezone";
import { postEndingARK, getDataScannedOrNot, postEndingcloseCalibration, postGetotpDetailscaliEnd } from "../../Service/AllServicesAPI";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { Routes } from "../../routes";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, } from "@fortawesome/free-solid-svg-icons";
import Toast from 'react-bootstrap/Toast';
import { fetchOtp, deleteOtp } from "../../Service/AllProductionAPI"
// import OtpFormBased from "../../components/OtpFormBased";
const validationSchema = Yup.object({
  arkNo: Yup.string().required("Required *"),
});
export default function EndingARkModal({ status, someData, handleClose }) {
  const [dispenserSrNo, setGenerateUniqueDispenser] = useState("");
  const [subOprationType, setSubOperationT] = useState("");
  const [oprationType, setOprationType] = useState("");
  const [volumeTotalizer, setVolumeTr] = useState("");
  const [digitalSignature, setDigitalSignature] = useState("");
  const [isOtpdisable, setOtpdisable] = useState(true);
  const [isgetotpButtonEnabled, SetisgetotpButtonEnabled] = useState(false);
  const [isclosecalibtarionButtonEnabled, SetisclosecalibtarionButtonEnabled] = useState(false);
  const [iscalibrationbutton, setiscalibrationbutton] = useState(false);
  const [arkNo, setArkNo] = useState("");
  const [otpData, setOtpData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(true);
  const [closeComp, SetCloseComp] = useState(true);
  const [arkError, setArkError] = useState("");
  const [fkRoManagerId,setfkRoManagerId]= useState("");

  // loading text in button 
  const [loadingbutton, setLoadingbutton] = useState(false);

  let type = null;
  const history = useHistory();
  useEffect(() => {
    setGenerateUniqueDispenser(someData?.generateUniqueDispenserNo);
    setSubOperationT(someData?.subOprationType);
    setVolumeTr(someData?.volumeTotalizer);
    setDigitalSignature(someData?.digitalSignature || "");   // added this digitalSignature for validation (until digitalsignature not valid in form dont show ending calibrationform)
    setOprationType("End Calibration");                      // added "End Calibration"
    setfkRoManagerId(someData.fkRoManagerId);
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  const token = sessionStorage.getItem("token");
  const fkUserId = sessionStorage.getItem("pkUserId");

  const fetchOtpFromApi = async () => {
    if (!fkUserId || !token) {
      console.error("Missing fkUserId or token in sessionStorage.");
      return;
    }

    try {
      setLoading(true);
      const fetchedData = await fetchOtp(fkUserId, token);
      console.log("Fetched OTP Data (Navbar):", fetchedData);

      if (fetchedData?.otp) {
        setOtpData(fetchedData);
      } else {
        setOtpData(null);
        console.warn("No OTP data found.");
      }
    } catch (error) {
      console.error("Error fetching OTP:", error);
    } finally {
      setLoading(false);
    }
  };


  // new get opt without any delay message
  const HandleSendOtpcaliend = async () => {
    console.log("ARK no. checking", arkNo);
    setLoadingbutton(true)
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    const payload = {
      generateUniqueDispenserNo: dispenserSrNo,
      arkNo: arkNo,
      oprationType: oprationType,
      subOprationType: subOprationType,
      volumeTotalizer: volumeTotalizer,
      fkRoManagerId:fkRoManagerId,
    };


    setOtpdisable(true);

    try {

      const response = await postGetotpDetailscaliEnd(payload, headers);

      const { message, status } = response.data;

      if (status === 200) {
        if (message === "First Generate ARK ON Dispenser Then, SCAN.") {
          swal("Info", message, "info");
        } else if (message === "Scanning Required..") {
          swal("", message, "warning");
        } else if (message === "Ending ARK verification Failed") {
          swal("", "Ending ARK verification Failed", "error");
        } else if (message === "ARK Ending Varification Failed") {
          swal("", "ARK Ending Verification Failed", "error");
        } else if (message === "Calibration details added successfully") {
          swal("Great", "Calibration end details added successfully", "success");

          fetchOtpFromApi();
          setOtpdisable(false);
          setLoadingbutton(true)
          setTimeout(() => {
            setOtpdisable(true);
          }, 120000);

          SetisclosecalibtarionButtonEnabled(true);
        } else {
          swal("Failed", "Unexpected response message", "error");
        }
      } else {
        swal("Error", "Unexpected status code", "error");
      }
    } catch (error) {

      console.log("Error sending OTP:", error);
      swal("Failed", "Failed to send OTP", "error");
    }
    finally {

      setLoadingbutton(false)
    }
  };

  // const handleArkChange = (e) => {
  //   const value = e.target.value.toUpperCase();


  //   if (!/^[A-Z0-9]*$/.test(value)) return;


  //   if (value.length > 10) return;

  //   setArkNo(value);

  //   // custom validation
  //   if (value.length < 10) {
  //     setArkError("ARK No. length must be exactly 10  ");
  //   } else {
  //     setArkError("");
  //   }
  // };


  // this function created for close the end calibration form and redirect to the calibration work order list
  const handleClosetolist = () => {
    history.push(`${Routes.VerificationCalibrationList.path}`);
  }

  const handleDeleteOtp = async () => {
    if (!otpData?.pkFieldotpId) {
      console.error("OTP ID not found.");
      return;
    }

    try {
      setLoading(true);
      const result = await deleteOtp(otpData.pkFieldotpId);

      if (result.success) {
        console.log("OTP deleted successfully.");
        setOtpData(null); // Remove from UI
      } else {
        alert("Failed to delete OTP.");
      }
    } catch (error) {
      console.error("Error deleting OTP:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={status} onHide={handleClosetolist} className="modal1">
      {/* <form onSubmit={formik.handleSubmit}> */}
      <Modal.Header closeButton>
        {/* <Modal.Title>Access Control</Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{
            generateUniqueDispenserNo: "",

          }}
          // validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            try {
              // code that we will 'try' to run
              const data = {

                generateUniqueDispenserNo: dispenserSrNo,

              };
              // console.log("Ending ARK Data", data);
              const token = sessionStorage.getItem("token");
              const headers = { Authorization: `Bearer ${token}` };


              await postEndingcloseCalibration(data, headers)
                .then((result) => {
                  console.log("Add Ending ARK Data", result);
                  const message = result.data.message;
                  if (message === "ARK Ending Varification Failed" || message === "Ending ARK verification Failed") {
                    swal("Failed", "End ARK verification failed", "error");
                  } else if (message === "Calibration details job Work Order is Not Valid ") {
                    swal("", "Calibration details job Work Order is not valid", "warning");
                  } else if (message === "Work Order Closed..") {
                    swal("Great", "Calibration work order closed successfully", "success");
                    handleDeleteOtp()
                    SetCloseComp(false)
                    console.log(message)
                    setiscalibrationbutton(true)
                  } else {

                  }
                  resetForm();

                  setTimeout(() => {
                    handleClose();
                  }, 7000);
                })
                .catch((error) => {
                  console.log("Ending ARK Error :-", error);
                  if (error.response.status === 400) {
                    swal("Failed", `${error.response.data.message}`, "error");
                  }
                });
            } catch (error) {
              console.log(error);
            }
          }
          }

        >
          {(formik) => {
            const { isValid, dirty, isSubmitting, values } = formik;

            const isarkentered = arkNo.length === 6 &&
              !arkError && volumeTotalizer;


            return (
              <>
                <Card border="light" className="bg-white shadow-sm mb-4 ">
                  <Col md={6} className="mb-3 d-flex flex-wrap">
                    <button
                      type="button"
                      className="btn btn-secondary m-2"
                      onClick={handleClose}
                    >
                      <FontAwesomeIcon icon={faAngleLeft} className="me-2" />{" "}
                      Back to Calibration Start
                    </button></Col>

                  <Card.Body>

                    <h5 className="head1 mb-4">Submit Calibration Ending Form</h5>
                    <Form>
                  
                      
                        

            
                      <Row>

                          <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Dispenser Serial No
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="generateUniqueDispenserNo"
                              placeholder="Dispenser Serial No."
                              title="Enter dispenser sr no"
                              value={dispenserSrNo}
                              readOnly
                            />
                          </div>
                        </Col>

                       
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Operation Type
                            </label>
                            <Field
                              name="oprationType"
                              title="Select OTP"
                              type="text"
                              className="form-control"
                              placeholder="Select OTP"
                              value="End Calibration"
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Sub Operation Type
                            </label>
                            <Field
                              name="subOprationType"
                              className="form-control"
                              type="text"
                              title="Select Sub Operation"
                              placeholder="Select Operation"
                              value={subOprationType}
                              readOnly
                            />
                          </div>
                        </Col>
                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">ARK No *</label>
                            <Field
                              type="text"
                              className="form-control"
                              // name="arkNo"
                              value={arkNo}
                              placeholder="ARK No."
                              title="Enter ARK no."
                              autoComplete="off"
                              // onChange={(e) => setArkNo(e.target.value)}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^[A-Z0-9]*$/.test(value) && value.length <= 6) {
                                  setArkNo(value);
                                }
                              }}
                            />
                            {/* <Field
                              type="text"
                              className="form-control"
                              value={arkNo}
                              placeholder="Enter ARK No."
                              autoComplete="off"
                              onChange={handleArkChange}
                            />
                            {arkError && <div className="text-danger mt-1">{arkError}</div>} */}
                          </div>
                        </Col>
                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Volume Totalizer *
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="volumeTotalizer"
                              placeholder="Enter Volume Totalizer"
                              title="Enter Volume Totalizer"
                              value={volumeTotalizer}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,10}(\.\d{0,2})?$/.test(value)) {
                                  setVolumeTr(value);
                                }
                              }}
                              required
                            />
                            <ErrorMessage name="volumeTotalizer" component={TextError} />
                          </div>
                        </Col> 
                      </Row>
                      {/* <div className="mt-3">
                        <Button variant="primary" disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting} type="submit">
                          End ARK Verification{" "}
                        </Button>
                      </div> */}
                      <Row>
                        <Col md={6} className="mb-3 d-flex flex-wrap">


                          <div className="form-group">
                            <button
                              type="button"
                              className="btn btn-info m-2 flex-grow-1"
                              onClick={HandleSendOtpcaliend}
                              disabled={!isOtpdisable || !isarkentered}
                            >
                              {loadingbutton ? (
                                <>

                                  <span className="ms-2">Please wait...</span>
                                </>
                              ) : (
                                "Get OTP"
                              )}
                            </button>
                          </div>

                        </Col>
                        <Col md={6} className="mb-3 d-flex flex-wrap">
                          <div className="form-group">
                            <button
                              type="submit"
                              className="btn btn-primary m-2 flex-grow-1"
                              disabled={!isclosecalibtarionButtonEnabled || iscalibrationbutton}

                            >
                              Close Calibration End
                            </button>
                          </div>
                        </Col>


                      </Row>
                      {/* <OtpFormBased/> */}
                      {/* {otpData?.template && showToast ? (
                        <Toast
                          onClose={() => setShowToast(false)}
                          show={showToast}
                          delay={1004456646400}
                          autohide
                          style={{
                            position: 'absolute',
                            right: '20px',
                            top: '520px',
                            marginBottom: '20px',
                            zIndex: '10000',
                            backgroundColor: '#007bff',
                            color: 'white',
                          }}
                        >
                          <Toast.Header>
                            <img
                              src="holder.js/20x20?text=%20"
                              className="rounded me-2"
                              alt=""
                            />
                            <strong className="me-auto text-black">Calibration End OTP Notification</strong>
                          </Toast.Header>
                          <Toast.Body>{otpData.template}</Toast.Body>
                        </Toast>
                      ) : null} */}
                    </Form>
                  </Card.Body>
                </Card>
              </>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

